import {
  DSIconModule,
  DS_ICON_CONFIGURATION,
  IconService,
  shuffle3DCursorAlt,
  shuffle3DMprToggle,
  shuffleAdd,
  shuffleAddAlt,
  shuffleAddComment,
  shuffleAddFilled,
  shuffleAlarm,
  shuffleArrowDown,
  shuffleArrowDownRight,
  shuffleArrowLeft,
  shuffleArrowRight,
  shuffleArrowUp,
  shuffleArrowsHorizontal,
  shuffleArrowsVertical,
  shuffleBook,
  shuffleBullhorn,
  shuffleCalendar,
  shuffleCamera,
  shuffleCaretDown,
  shuffleCaretRight,
  shuffleCaretSortDown,
  shuffleCaretUp,
  shuffleCatalog,
  shuffleCdCreateExchange,
  shuffleCenterCircle,
  shuffleCenterSquare,
  shuffleCenterToFit,
  shuffleChangeCatalog,
  shuffleChart3D,
  shuffleChartVennDiagram,
  shuffleChat,
  shuffleCheck,
  shuffleCheckmark,
  shuffleCheckmarkFilled,
  shuffleChevronDown,
  shuffleChevronLeft,
  shuffleChevronRight,
  shuffleChevronSortDown,
  shuffleChevronUp,
  shuffleCircleFilled,
  shuffleCircleMeasurement,
  shuffleClean,
  shuffleClose,
  shuffleCloudSatellite,
  shuffleCollapseSidenav,
  shuffleCollapseSidenav2,
  shuffleColorPalette,
  shuffleConnect,
  shuffleContrast,
  shuffleCopy,
  shuffleCrop,
  shuffleCube,
  shuffleCubeView,
  shuffleCut,
  shuffleCutInHalf,
  shuffleCutOut,
  shuffleDashboard,
  shuffleDataBase,
  shuffleDataTable,
  shuffleDocument,
  shuffleDocumentBlank,
  shuffleDocumentDownload,
  shuffleDocumentExport,
  shuffleDocumentImport,
  shuffleDocumentSubtract,
  shuffleDotMark,
  shuffleDownToBottom,
  shuffleDownload,
  shuffleDragIndicator,
  shuffleEdit,
  shuffleEmptyStateAddObjectDark,
  shuffleError,
  shuffleErrorFilled,
  shuffleErrorOutline,
  shuffleExpandSidenav,
  shuffleExpandSidenav2,
  shuffleFilter,
  shuffleFilterEdit,
  shuffleFilterReset,
  shuffleFitToScreen,
  shuffleFlow,
  shuffleFlowData,
  shuffleGroup,
  shuffleHelp,
  shuffleInformation,
  shuffleInformationFilled,
  shuffleInsert,
  shuffleListNumbered,
  shuffleLocked,
  shuffleLogout,
  shuffleMagicWandFilled,
  shuffleMaximize,
  shuffleModelBuilder,
  shuffleMove,
  shuffleNotebook,
  shuffleNotification,
  shuffleOverflowHorizontal,
  shuffleOverflowMenuHorizontal,
  shuffleOverflowMenuVertical,
  shuffleOverflowVertical,
  shufflePaintBrush,
  shufflePerson,
  shufflePortfolio,
  shuffleRecentlyViewed,
  shuffleReport,
  shuffleReset,
  shuffleResetAlt,
  shuffleRotate360,
  shuffleRotateClockwise,
  shuffleRotateClockwiseAltFilled,
  shuffleRotateCounterclockwise,
  shuffleRss,
  shuffleRuler,
  shuffleRulerAlt,
  shuffleScale,
  shuffleScales,
  shuffleScatterMatrix,
  shuffleSearch,
  shuffleSelect01,
  shuffleSend,
  shuffleSendAlt,
  shuffleSendFilled,
  shuffleSettings,
  shuffleShapeExcept,
  shuffleShare,
  shuffleShoppingCatalog,
  shuffleSkillLevelAdvanced,
  shuffleSprayPaint,
  shuffleSubVolume,
  shuffleSubtract,
  shuffleSubtractAlt,
  shuffleSupport,
  shuffleTable,
  shuffleTableSplit,
  shuffleTag,
  shuffleTagGroup,
  shuffleTask,
  shuffleTextHighlight,
  shuffleThumbnail,
  shuffleTime,
  shuffleTrash,
  shuffleTrashCan,
  shuffleUnlocked,
  shuffleUpload,
  shuffleUser,
  shuffleUserActivity,
  shuffleUserAvatar,
  shuffleUserMultiple,
  shuffleView,
  shuffleViewOff,
  shuffleWarning,
  shuffleWarningAlt,
  shuffleWarningAltFilled,
  shuffleWarningFilled,
  shuffleZAxis,
} from '@akso/shuffle-ds';
import { NgModule } from '@angular/core';

const shuffleIcons = [
  shuffleFilterEdit,
  shuffleDashboard,
  shufflePortfolio,
  shuffleSettings,
  shuffleFlow,
  shuffleUserMultiple,
  shuffleTableSplit,
  shuffleSend,
  shuffleTask,
  shuffleBook,
  shuffleTag,
  shuffleArrowsHorizontal,
  shuffleArrowLeft,
  shuffleArrowRight,
  shuffleUpload,
  shuffleAdd,
  shuffleInformation,
  shuffleDocument,
  shuffleDocumentBlank,
  shuffleDocumentDownload,
  shuffleClose,
  shuffleTrash,
  shuffleDownload,
  shuffleChevronDown,
  shuffleChevronRight,
  shuffleDragIndicator,
  shuffleSearch,
  shuffleChevronUp,
  shuffleEdit,
  shuffleDownToBottom,
  shuffleAddAlt,
  shuffleAddFilled,
  shuffleOverflowVertical,
  shuffleChat,
  shuffleAlarm,
  shuffleSendFilled,
  shuffleInformationFilled,
  shuffleRecentlyViewed,
  shuffleCheckmark,
  shuffleLogout,
  shuffleDotMark,
  shuffleOverflowMenuHorizontal,
  shuffleOverflowMenuVertical,
  shuffleFilter,
  shuffleError,
  shuffleCalendar,
  shuffleChevronSortDown,
  shuffleTime,
  shuffleClean,
  shuffleChevronLeft,
  shuffleWarningFilled,
  shuffleDataBase,
  shuffleArrowUp,
  shuffleArrowDown,
  shuffleArrowDownRight,
  shuffleUserAvatar,
  shuffleTrashCan,
  shuffleCaretRight,
  shuffleView,
  shuffleViewOff,
  shuffleCenterCircle,
  shuffleCircleFilled,
  shuffle3DMprToggle,
  shuffleAddComment,
  shuffleCaretDown,
  shuffleCaretUp,
  shuffleCenterToFit,
  shuffleChartVennDiagram,
  shuffleCircleMeasurement,
  shuffleColorPalette,
  shuffleContrast,
  shuffleCrop,
  shuffleCubeView,
  shuffleCut,
  shuffleCutInHalf,
  shuffleCutOut,
  shuffleErrorFilled,
  shuffleFilterReset,
  shuffleFitToScreen,
  shuffleInsert,
  shuffleLocked,
  shuffleMagicWandFilled,
  shuffleModelBuilder,
  shuffleOverflowHorizontal,
  shufflePaintBrush,
  shuffleReset,
  shuffleResetAlt,
  shuffleRotateClockwiseAltFilled,
  shuffleRss,
  shuffleRuler,
  shuffleSelect01,
  shuffleShapeExcept,
  shuffleShare,
  shuffleShoppingCatalog,
  shuffleSkillLevelAdvanced,
  shuffleSprayPaint,
  shuffleSubtract,
  shuffleSubVolume,
  shuffleTextHighlight,
  shuffle3DCursorAlt,
  shuffleRotateClockwise,
  shuffleRotateCounterclockwise,
  shuffleSubtractAlt,
  shuffleCopy,
  shuffleCloudSatellite,
  shuffleHelp,
  shuffleWarning,
  shuffleEmptyStateAddObjectDark,
  shuffleCatalog,
  shuffleChangeCatalog,
  shuffleZAxis,
  shuffleMaximize,
  shuffleTagGroup,
  shuffleWarningAlt,
  shuffleWarningAltFilled,
  shuffleListNumbered,
  shuffleNotebook,
  shuffleCheckmarkFilled,
  shuffleScales,
  shuffleRulerAlt,
  shuffleDocumentExport,
  shuffleDocumentImport,
  shuffleSendAlt,
  shuffleUser,
  shuffleUserActivity,
  shuffleCaretSortDown,
  shuffleScatterMatrix,
  shuffleDocumentSubtract,
  shuffleArrowsVertical,
  shuffleSupport,
  shuffleThumbnail,
  shuffleNotification,
  shuffleMove,
  shuffleCube,
  shuffleChart3D,
  shuffleFlowData,
  shuffleConnect,
  shuffleRotate360,
  shuffleScale,
  shufflePerson,
  shuffleCenterSquare,
  shuffleCamera,
  shuffleCdCreateExchange,
  shuffleErrorOutline,
  shuffleUnlocked,
  shuffleReport,
  shuffleGroup,
  shuffleBullhorn,
  shuffleCollapseSidenav,
  shuffleCollapseSidenav2,
  shuffleExpandSidenav,
  shuffleExpandSidenav2,
  shuffleCheck,
  shuffleDataTable,
  shuffleTable,
];

/**
 * @deprecated by MatIconRegistry
 */
@NgModule({
  exports: [DSIconModule],
  providers: [
    IconService,
    {
      provide: DS_ICON_CONFIGURATION,
      multi: true,
      useValue: {
        icons: shuffleIcons,
      },
    },
  ],
})
export class CustomDSIconModule {}
